module.exports = __webpack_public_path__ + "img/eng_dhfesta_info_0401_big.b6f5cc48.png";